<template>
  <v-row dense justify="center">
    <v-col cols="12" class="title d-flex align-center">
      <v-icon color="secondary" left>mdi-folder</v-icon> Cursos
    </v-col>
    <v-col cols="12" md="4" v-for="item in courses" :key="item.title">
      <v-sheet outlined rounded class="fill-height">
        <v-list-item two-line :to="item.status === 'E' ? {name: 'salaDeAula', params: {matriculaId: item.id}} : null">
          <v-list-item-avatar>
            <v-icon class="white lighten-1" :class="{'secondary--text': item.status === 'E'}">mdi-folder</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.group.syllabus.course.name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <small>Curso {{ getEnrollmnetStatus(item.status)}}</small>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              Turma {{ item.group.name }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              Ementa {{ item.group.syllabus.name }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon class="secondary--text" v-if="modules.financial" @click.prevent="fetchPaymentData(item)">
              <v-icon>mdi-cash</v-icon>
            </v-btn>
            <v-btn icon class="secondary--text" @click.prevent="item.modal = true">
              <v-icon>mdi-information</v-icon>
            </v-btn>
            <v-btn icon class="secondary--text" :to="{ name: 'ambienteAluno.course.quadroDeNotas', params: { matriculaId: item.id } }">
              <v-icon>mdi-chart-timeline-variant</v-icon>
            </v-btn>
            <v-btn icon class="secondary--text" :to="{ name: 'ambienteAluno.course.avaliacoes', params: { matriculaId: item.id, groupId: item.group.id } }">
              <v-icon>mdi-file-document-outline</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-dialog v-model="item.modal" max-width="500px">
            <v-card>
              <v-card-title class="subheading">
                <b>Detalhes da matrícula {{ item.number }}</b>
              </v-card-title>
              <v-card-text class="text-xs-left">
                <div><b>Data da matrícula:</b> {{getDateFormat(item.created_at)}}</div>
                <div><b>Curso:</b> {{item.group.syllabus.course.name}}</div>
                <div><b>Ementa:</b> {{item.group.syllabus.name}}</div>
                <div><b>Turma:</b> {{item.group.name}}</div>
                <div>Sua matrícula neste curso está com o status {{ getEnrollmnetStatus(item.status) }}.</div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click.stop="item.modal=false">Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-if="modules.financial && item.transactionModal" v-model="item.transactionModal" max-width="500px">
            <v-card>
              <v-card-title class="subheading">
                <span>Detalhes do Pagamento</span>
              </v-card-title>
              <v-card-text class="text-xs-left">
                <v-layout justify-space-between wrap>
                  <span>
                    Pago
                    <span v-if="transaction.installments > 1"> em {{ transaction.installments }}x </span>
                    <span v-else> a vista </span>
                    com <span class="font-weight-bold">{{ paymentMethod }}</span>
                    no dia <span class="font-weight-bold">{{ transaction.date | date }}</span>
                  </span>
                </v-layout>
                <ul class="leading-dots mt-3">
                  <li v-for="transactionItem in transaction.items" :key="transactionItem.id">
                    <span><strong>{{ transactionItem.quantity }}x {{ transactionItem.title }}</strong></span><span>{{ transactionItem.unit_price | money }}</span>
                  </li>
                </ul>
                <hr class="my-3">
                <ul class="leading-dots">
                  <li>
                    <span><strong>Total</strong></span><span>{{ transaction.amount | money }}</span>
                  </li>
                </ul>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click.stop="item.transactionModal = false">Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-list-item>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { Course, Transaction } from '@/services/resources'
import Util from '@/services/util'
import { mapGetters } from 'vuex'

export default {
  mounted () {
    Course.list()
      .then(response => {
        const courses = response.data.courses
        this.courses = courses.map(element => {
          element.modal = false
          element.transactionModal = false
          return element
        })
      })
      .catch(responseError => {
        console.log('Erro', responseError)
      })
  },
  data () {
    return {
      courses: [],
      transaction: {}
    }
  },
  methods: {
    getDateFormat (dateTime) {
      return (new Date(dateTime)).toLocaleDateString(window.navigator.language)
    },
    fetchPaymentData (enrollment) {
      Transaction.fetch(enrollment.id)
        .then(response => {
          this.transaction = response.data
          enrollment.transactionModal = true
        })
    },
    getEnrollmnetStatus (status) {
      return Util.getEnrollmentStatusString(status)
    }
  },
  computed: {
    paymentMethod () {
      if (this.transaction.payment_method) {
        switch (this.transaction.payment_method) {
          case 'credit_card':
            return 'Cartão de Crédito(' + this.transaction.card_brand + ' ' + this.transaction.card_last_digits + ')'
          case 'boleto':
            return 'Boleto'
        }
      }
      return ''
    },
    ...mapGetters({
      modules: 'App/modules'
    })
  },
  filters: {
    money (val) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2
      }).format(val / 100)
    },
    date (val) {
      console.log(new Date(val.substring(0, 10)))
      return new Intl.DateTimeFormat('pt-BR').format(new Date(val.substring(0, 10)))
    }
  }
}
</script>

<style lang="scss" scoped>
ul.leading-dots {
    max-width: 40em;
    padding: 0;
    overflow-x: hidden;
    list-style: none}
ul.leading-dots li:before {
    float: left;
    width: 0;
    white-space: nowrap;
    content:
 ". . . . . . . . . . . . . . . . . . . . "
 ". . . . . . . . . . . . . . . . . . . . "
 ". . . . . . . . . . . . . . . . . . . . "
 ". . . . . . . . . . . . . . . . . . . . "}
ul.leading-dots span:first-child {
    padding-right: 0.33em;
    background: white
}
ul.leading-dots span + span {
    float: right;
    padding-left: 0.33em;
    background: white}
</style>
